import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Badge, Skeleton, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useSingleConsultationQuery } from 'app/services/edpApiV1/consultations';
import { dataForTableUserConsultations, dataForUserConsultations, sortingDate } from 'shared/helpers/utils';
import Chat from 'features/chat';
import { useIndicators } from 'features/indicators';
import {
  TSingleConsultationPreparedData,
  TSingleConsultationPreparedTableData,
} from 'shared/types/consultations.types';
import ConsultationUserForm from '../consultationsForms/consultationUserForm';
import style from './index.module.scss';

/**
 * @page Consultations user subordination
 */

const columns: ColumnsType<TSingleConsultationPreparedTableData> = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'key',
    width: 140,
  },
  {
    title: 'Дата',
    dataIndex: 'created',
    key: 'created',
    sorter: (a, b) => sortingDate(a.created, b.created),
  },
  {
    title: 'Тема',
    dataIndex: 'topic',
    key: 'topic',
  },
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Должность',
    dataIndex: 'position',
    key: 'position',
  },
  {
    title: 'Подразделение',
    dataIndex: 'division',
    key: 'division',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <span>
        <Badge status={status.type} />
        {status.text}
      </span>
    ),
  },
];

const ConsultationUserSubordination = () => {
  const [dataConsultations, setDataConsultations] = useState<TSingleConsultationPreparedData[]>();
  const tableData = useRef<TSingleConsultationPreparedTableData[]>();
  const { id } = useParams();

  const {
    data: consultation,
    isLoading,
    refetch: consultationRefetch,
    isSuccess,
    isFetching,
  } = useSingleConsultationQuery(Number(id));

  useEffect(() => {
    if (consultation) {
      const dataConsultation = dataForUserConsultations(consultation);
      const dataForTable = dataForTableUserConsultations(consultation);
      tableData.current = dataForTable;
      setDataConsultations(dataConsultation);
    }
  }, [consultation]);

  useIndicators(isSuccess, isFetching);

  return (
    <>
      <div className={style.wrap}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            <Table dataSource={tableData.current} columns={columns} pagination={false} bordered />
            {dataConsultations && (
              <ConsultationUserForm dataConsultations={dataConsultations} consultationRefetch={consultationRefetch} />
            )}
          </>
        )}
      </div>
      <Chat id={Number(id)} />
    </>
  );
};

export default ConsultationUserSubordination;
